export default __webpack_public_path__ + "static/media/storageUnit1-afterC-1440w.3a685a65.webp";